import { render, staticRenderFns } from "./ProfilePageWallCardSkeleton.vue?vue&type=template&id=465b588f&"
import script from "./ProfilePageWallCardSkeleton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ProfilePageWallCardSkeleton.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports